import { Route } from 'react-router-dom';
import AuthPage from '../../pages/raptor/auth/login.page';
import ForgotPasswordPage from '../../pages/raptor/auth/forgot-password.page';
import ResetPasswordPage from '../../pages/raptor/auth/reset-password.page';

export const RaptorAuthRoutes = (
  <>
    <Route path="login" element={<AuthPage />} />
    <Route path="forgot-password" element={<ForgotPasswordPage />} />
    <Route path="reset-password" element={<ResetPasswordPage />} />
  </>
);
